import DealTaxesExpandedTable from './DealTaxesExpandedTable';

export { DealTaxesExpandedTable };
